export interface PinnedPrompt {
	id: string
	text: string
	createdAt: string
}

const PINNED_PROMPTS_KEY = 'platform-assistant-pinned-prompts'
const MAX_PINNED = 12

function createPinnedPromptId(): string {
	if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
		return crypto.randomUUID()
	}
	return `${Date.now()}-${Math.random().toString(36).slice(2, 9)}`
}

export function getPinnedPrompts(): PinnedPrompt[] {
	try {
		const stored = localStorage.getItem(PINNED_PROMPTS_KEY)
		if (!stored) return []
		const parsed = JSON.parse(stored)
		return Array.isArray(parsed) ? parsed.slice(0, MAX_PINNED) : []
	} catch {
		return []
	}
}

export function pinPrompt(text: string): PinnedPrompt[] {
	const trimmed = text.trim()
	if (!trimmed) return getPinnedPrompts()

	const existing = getPinnedPrompts().filter((prompt) => prompt.text !== trimmed)
	const pinned: PinnedPrompt = {
		id: createPinnedPromptId(),
		text: trimmed,
		createdAt: new Date().toISOString(),
	}
	const updated = [pinned, ...existing].slice(0, MAX_PINNED)
	try {
		localStorage.setItem(PINNED_PROMPTS_KEY, JSON.stringify(updated))
	} catch {
		// ignore storage failures
	}
	return updated
}

export function unpinPrompt(id: string): PinnedPrompt[] {
	const updated = getPinnedPrompts().filter((prompt) => prompt.id !== id)
	try {
		localStorage.setItem(PINNED_PROMPTS_KEY, JSON.stringify(updated))
	} catch {
		// ignore storage failures
	}
	return updated
}

export function isPromptPinned(text: string): boolean {
	const trimmed = text.trim()
	return getPinnedPrompts().some((prompt) => prompt.text === trimmed)
}
